<template>
  <v-dialog v-model="dialog" persistent max-width="800px">
    <v-container>
      <v-card>
        <v-toolbar class="headline" color="primary" dark>食事設定（日毎）</v-toolbar>
        <v-card-title class="noPaddingBtm">
          {{this.viewTime}}
        </v-card-title>
        <v-card-title class="noPaddingTopBtm">
          <v-switch v-model="teikyouSwitch" color="success" :label="`提供あり`" :disabled="switchCtrl" dense>
          </v-switch>
        </v-card-title>
        <v-card-text>
          <v-card class="HigotoTextBox">
            <v-card-text>
              <v-container style="height: 216px;overflow-y: auto;">
                <v-row v-for="(item, index) in contentValue" :key="index">
                  <v-col cols="1">
                    <v-subheader>{{item.meal_class}}</v-subheader>
                  </v-col>
                  <v-col cols="4">
                    <v-subheader :style="GetBgRGB(index)">
                      <div class="MenuStyle">
                        {{item.meal_name}}
                      </div>
                    </v-subheader>
                  </v-col>
                  <v-col cols="7">
                    <ryou-input label="食事メニュー" v-model="item.menu" :value="item.menu" :maxlength="15"
                      :disabled="inpBtnCtrl">
                    </ryou-input>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <ryou-black-btn :label="'閉じる'" :handlerClick="handleCancel" :disabled="ryouBtnCtrl"
                :iconCls="'mdi-close'"></ryou-black-btn>
              <v-spacer></v-spacer>
              <ryou-black-btn :label="'設定'" :handlerClick="confirm" :disabled="inpBtnCtrl || ryouBtnCtrl">
              </ryou-black-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-card-text>
      </v-card>
    </v-container>
    <ryou-confirm ref="confirm"></ryou-confirm>
  </v-dialog>
</template>

<script>
  import RyouInput from "@/components/formInput/RyouInput.vue";
  import RyouBlackBtn from "@/components/formInput/RyouBlackBtn.vue";
  import RyouConfirm from "@/components/dialog/RyouConfirm.vue";

  export default {
    name: "MealLunchDialog",
    components: {
      RyouInput,
      RyouBlackBtn,
      RyouConfirm,
    },
    data() {
      return {
        dialog: false,
        time: "",
        viewTime: "",
        watchTeikyouSwitch: null,
        teikyouSwitch: null,
        dialogMealNames: [],
        contentValue: [],
        ryouBtnCtrl: false,
        switchCtrl: null,
        inpBtnCtrl: null,
        dialogReservFlg: null,//true:締め切り以下、false:締切日より小さくない 
        groupOptionValue: "",
        updateResult: {}
      };
    },
    watch: {
      teikyouSwitch(value) {
        if (!value) {
          this.contentValue.forEach((item) => {
            item.menu = "";
          });
          this.inpBtnCtrl = true;
        }

        if (this.dialogReservFlg) {
          this.inpBtnCtrl = true;
          this.switchCtrl = true;
        }
        else {
          if (value) {
            this.inpBtnCtrl = false;
          }
          else {
            this.inpBtnCtrl = true;
          }
        }
      }
    },
    methods: {
      sortbyKey(arr, key) {
        if (arr.length > 0) {
          return arr.sort((a, b) => {
            let x = a[key];
            let y = b[key];

            return x - y;
          })
        }
      },
      //クリックを閉じる
      handleCancel() {
        this.close();
      },
      watchingTeikyouSwitch(value) {

        this.watchTeikyouSwitch = value;

        let updateResultBean = {
          build_group_id: this.groupOptionValue,
          input_date: this.time,
          offer_flg: Number(this.teikyouSwitch).toString(),
          user_id: this.$store.getters.getUserId,
        };

        this.putRequest("/mealLunchSetting/mealOfferTUpdate", updateResultBean, this.$store.getters.getUserToken);
      },
      removeWatchingTeikyouSwitch() {

        if (this.unwatch) {
          this.unwatch();
        }
      },
      //クリックを確定
      confirm() {
        this.$refs.confirm.open("更新", "更新します。宜しいですか？", { color: "info" })
          .then((confirm) => {
            if (confirm) {
              this.submit();
            }
          });
      },
      submit() {

        let updateResultBean = {
          build_group_id: this.groupOptionValue,
          input_date: this.time,
          user_id: this.$store.getters.getUserId,
          menu_entity: []
        };
        this.updateResult = updateResultBean;

        this.contentValue.forEach((item) => {
          let updateItem = {
            meal_class: item.meal_class,
            menu: item.menu,
          };
          this.updateResult.menu_entity.push(updateItem);
        });

        this.ryouBtnCtrl = true;
        this.putRequest("/mealLunchSetting/mealMenuUpdate", this.updateResult, this.$store.getters.getUserToken).then((resp) => {
          if (resp.success) {
            this.ryouBtnCtrl = false;
            this.close();
          }
        });
      },
      //ページローディング要求インターフェース、取得値
      // パラメータ1:ダイアログデータ、パラメータ2:物件グループID
      // パラメータ3:食事提供有無フラグ、パラメータ4:締め切りフラグ
      //パラメータ5:[食事区分&食事名]
      getInputValue(value, selectOptionValue, offerCheckFlg, reservCheckFlg, mealNames) {

        if (selectOptionValue) {
          this.groupOptionValue = selectOptionValue;
        }
        //タイプ判定
        if (value instanceof Object) {

          if (offerCheckFlg) {
            this.inpBtnCtrl = false;
          } else {
            this.inpBtnCtrl = true;
          }
          if (reservCheckFlg) {
            this.dialogReservFlg = true;
          } else {
            this.dialogReservFlg = false;
          }
          for (let dialogDataIndex in value) {
            this.time = dialogDataIndex;

            let timelist = dialogDataIndex.split("-");
            this.viewTime =
              timelist[0] + "年"
              + (timelist[1][0] == "0" ? timelist[1][1] : timelist[1]) + "月"
              + (timelist[2][0] == "0" ? timelist[2][1] : timelist[2]) + "日";

            this.contentValue = value[dialogDataIndex];
            if (this.contentValue[0].offer_flg != "") {
              this.teikyouSwitch = Number(this.contentValue[0].offer_flg);
              this.unwatch = this.$watch('teikyouSwitch', this.watchingTeikyouSwitch)
            }
          }
          if (mealNames) {
            this.dialogMealNames = mealNames;

            for (let dmnIndex = 0; dmnIndex < this.dialogMealNames.length; dmnIndex++) {

              let notExistFlg = 0;
              for (let cvIndex = 0; cvIndex < this.contentValue.length; cvIndex++) {

                if (this.dialogMealNames[dmnIndex].meal_class == this.contentValue[cvIndex].meal_class) {
                  notExistFlg += 0;
                } else {
                  notExistFlg += 1;
                }

              }

              if (notExistFlg == this.contentValue.length) {
                let emptyMenu = { "menu": "" };
                let contentItem = {
                  ...this.dialogMealNames[dmnIndex],
                  ...emptyMenu
                }
                this.contentValue.push(contentItem);
                this.sortbyKey(this.contentValue, 'meal_class');
              }
            }
          }
        }
        else {
          this.time = value;

          let timelist = value.split("-");
          this.viewTime =
            timelist[0] + "年"
            + (timelist[1][0] == "0" ? timelist[1][1] : timelist[1]) + "月"
            + (timelist[2][0] == "0" ? timelist[2][1] : timelist[2]) + "日";

          this.inpBtnCtrl = true;
          this.switchCtrl = true;
          this.teikyouSwitch = false;
          this.contentValue = [];
          this.dialogMealNames = [];
        }

        this.open();
      },
      close() {
        this.dialog = false;
        this.removeWatchingTeikyouSwitch();
        this.clearParameters();
        this.$emit("reCalendar");
      },
      open() {
        this.dialog = true;
      },
      GetBgRGB(value) {
        let BgRGB = [
          "#FF9800",//オレンジ
          "#673AB7",//深紫
          "#4CAF50",//緑
          "#E91E63",//ピンク
          "#3F51B5",//インディゴ
          "#009688",//teal
          "#FF5722",//深オレンジ
          "#8BC34A",//light-green
          "#D32F2F",//red darken-2
          "#1565C0"//blue darken-3
        ]
        if (this.dialogReservFlg) {
          return {
            background: "#795548"
          };
        }
        else {
          return {
            background: BgRGB[value]
          };
        }
      },
      // パラメータをクリア
      clearParameters() {
        this.teikyouSwitch = null;
        this.watchTeikyouSwitch = null;
        this.contentValue = [];
        this.dialogMealNames = [];
        this.dialogReservFlg = null;
        this.groupOptionValue = "";
        this.inpBtnCtrl = null;
        this.switchCtrl = null;
      }
    },
  };
</script>

<style scoped>
  .noPaddingBtm {
    padding-bottom: 0px;
  }

  .noPaddingTopBtm {
    padding-top: 0px;
    padding-bottom: 0px;
  }

  .HigotoTextBox {
    outline: 1px solid rgb(0, 225, 255);
  }

  .MenuStyle {
    width: 100%;
    height: 100%;
    color: white;
    font-weight: bold;
    text-align: center;
    line-height: 48px;
  }
</style>